import React from "react";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import AuditableInfo from "../AuditableInfo";
import { useUpdateCertificateNoteOrderMutation } from "./CertificateNotesApi";
import { hasPermission } from "../../../helpers/utils/AccessControlUtils";

interface CertificateNotes {
  id: string;
  comment: string;
  sortOrder: number;
}

interface CommonNotesFormProps {
  data: CertificateNotes[];
  title: string;
  count: number;
  companyId?: any
  type?: string,
  createPermission?: any,
  updatePermission?: any,
  deletePermission?: any,
  setNoteObject?: any,
  setShowNoteUpdateModel?: any,
  setShowDeleteConfirm?: any
  setShowAddNoteModal?: any,
  relationalId?: any,
  setNoteId?: any
}

const CommonCertificateNotesForm: React.FC<CommonNotesFormProps> = ({
  data,
  title,
  count,
  type = "certificate",
  relationalId,
  createPermission = "CRTNOT-C",
  updatePermission = "CRTNOT-U",
  deletePermission = "CRTNOT-D",
  setShowDeleteConfirm,
  setNoteId,
  setNoteObject,
  setShowNoteUpdateModel,
  setShowAddNoteModal,
}) => {
  const [updateCertificateNote] = useUpdateCertificateNoteOrderMutation();

  const sortNoteDraggableList = (props: any) => {
    const source = props.source.index;
    const destination = props.destination.index;
    const updatedData = [...data];
    const [movedItem] = updatedData.splice(source, 1);
    updatedData.splice(destination, 0, movedItem);

    updateCertificateNote({
      listIds: updatedData,
      relationalId: relationalId,
      type: type
    });
  }

  return (
    <div className="bg-text-1 shadow-lg text-sm rounded-md ">
      <div className="flex justify-between items-center border-b border-[rgba(0,0,0,0.1)] p-2">
        <h5 className="font-semibold text-surface-0 ">
          {title} ({count})
        </h5>
        {hasPermission([createPermission]) &&
          <i className="fa fa-plus-circle  cursor_hover text-highlight-0"
            title="Add Certificate Note..."
            data-toggle="modal" onClick={() => setShowAddNoteModal(true)}
            data-keyboard="false" />}
      </div>
      <div className={'p-2'}>
        <div className='overflow-y-auto max-h-52'>

          <DragDropContext onDragEnd={(props) => {
            sortNoteDraggableList(props);
          }}>

            <div className="with-max-d mt-1">
              {
                data && data?.length === 0 &&
                <div className="mt-1 border-2 border-surface-5 bg-text-0 p-2 rounded-sm">
                  <h3>
                    No notes to display
                  </h3>
                </div>
              }
              <Droppable droppableId="droppable-1">

                {(provided) => (

                  <div ref={provided.innerRef} {...provided.droppableProps}>
                    {
                      data && data?.length > 0 && data.map((curNote: any, i: any) => {
                        return (
                          <Draggable key={curNote.id} draggableId={curNote.id} index={i}>

                            {(provided, snapshot) => {
                              return (
                                <div
                                  className={"border border-text-1  card-margin mb-4" + `item ${snapshot.isDragging && "dragging"}`}
                                  ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}>
                                  <div className={curNote?.yellowHighlight === true ? "card-header pl-3 py-2 bg-[#ffff80]" : "bg-text-0 card-header pl-3 py-2"}>
                                    <div className=" sm:block md:flex justify-between">
                                      <div className="sm:block md:flex gap-2">
                                        {hasPermission([updatePermission]) &&
                                          <span>
                                            <i className='fa fa-edit text-highlight-0'
                                              onClick={() => {
                                                setNoteObject(curNote);
                                                setShowNoteUpdateModel(true);
                                              }} />
                                          </span>
                                        }
                                        {hasPermission([deletePermission]) &&

                                          <span>
                                            <i className="fa fa-trash mr-auto text-highlight-0"
                                              aria-hidden="true"
                                              onClick={() => {
                                                setNoteId(curNote.id);
                                                setShowDeleteConfirm(true)
                                              }} />
                                          </span>
                                        }
                                        <span
                                          className={`${curNote?.bold === true && curNote?.redColor === true
                                            ? "text-error-1 font-bold"
                                            : (curNote?.bold === false && curNote?.redColor === true
                                              ? "text-error-1"
                                              : "font-bold"
                                            )
                                            } break-words w-[35ch]`}
                                        >
                                          {curNote?.comment ?? curNote?.message}
                                        </span>
                                      </div>
                                      <AuditableInfo data={curNote} />

                                    </div>
                                  </div>
                                </div>
                              )
                            }
                            }
                          </Draggable>
                        )
                      }
                      )
                    }
                    {provided.placeholder}
                  </div>
                )}
              </Droppable>
            </div>
          </DragDropContext>
        </div>
      </div>

    </div>
  );
};

export default CommonCertificateNotesForm;
